
  import { mapGetters } from 'vuex';

  export default {
    props: {
      basePath: { type: String, required: true },
      i18nParams: { type: Object, default: () => {} },
      product: { type: String, required: true }
    },
    data () { return { expanded: {} }; },
    computed: {
      ...mapGetters('providers', { providers: 'getList' })
    },
    methods: {
      toggleExpanded (key) {
        const newValue = {};
        newValue[key] = !this.expanded[key];
        this.expanded = {};
        this.expanded = { ...this.expanded, ...newValue };
      }
    }
  };
